import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

import { callAPI } from "../feature/APISlice";
import { openForm } from "../feature/formSlice";
import AdminNavbar from "./AdminNavbar";
import EventsForm from "../Form/EventsForm";

const BASE_URL = `${process.env.REACT_APP_PRODUCTION_API_URL}backend/api/admin/events`;

export default function EventsList() {
  const dispatch = useDispatch();
  const { items, loading, error } = useSelector((s) => s.api);

  useEffect(() => {
    dispatch(callAPI({ method: "get", url: BASE_URL }));
  }, [dispatch]);
  const formatDate = (date) =>
    date ? new Date(date).toLocaleString() : "N/A";
  return (
    <div>
      <AdminNavbar />

      <div className="customcontainer">
        <button className="admin-btn outline" onClick={() => dispatch(openForm(null))}>
          + Add Event
        </button>

        {loading && <p>Loading...</p>}
        {error && <p className="error-text">{error}</p>}

        <div className="admin-card-grid">
          {items.map((e) => (
            <div className="admin-card" key={e.id}>
              <h4>{e.title}</h4>
              <p>Status: {e.is_active ? " Active" : "❌ Inactive"}</p>
              <p>Created By: {e.createdByName}</p>
              <p>Created Time: {formatDate(e?.createdTime)}</p>
              <p>Updated By: {e?.lastModifiedByName}</p>

              <p>Updated Time: {formatDate(e?.updatedTime)}</p>
              <div className="admin-card-actions">
                <button onClick={() => dispatch(openForm(e.id))}>✏️</button>
                <button
                  onClick={() =>
                    window.confirm("Delete?") &&
                    dispatch(callAPI({
                      method: "delete",
                      url: `${BASE_URL}/${e.id}`,
                      data: { id: e.id },
                    }))
                  }
                >
                  🗑️
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      <EventsForm />
    </div>
  );
}
